import PropTypes from "prop-types";

import { Badge } from "@/components/ui/badge";

ChartFilterBadges.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  style: PropTypes.object,
};

export default function ChartFilterBadges({ filters, style }) {
  if (!filters || filters.length === 0) return null;
  return (
    <div className="ml-1 mt-2 flex flex-wrap gap-1">
      {filters.map((filter, index) => (
        <Badge key={index} variant="outline" style={style}>
          {`${filter.name}: ${filter.value}`}
        </Badge>
      ))}
    </div>
  );
}
